import styled from 'styled-components'

export default styled.div`
  align-self: center;
  font-weight: bold;
`



// WEBPACK FOOTER //
// ./src/components/DashboardWidgets/UsersActivity/Row/ProgressPerc.js